module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/member-detail/member-detail.component.css
// module id = ./src/app/member-detail/member-detail.component.css
// module chunks = main